function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M5.471 7.529a.667.667 0 10-.942.942l.942-.942zM7 10l-.471.471a.666.666 0 00.983-.044L7 10zm3.845-3.573a.667.667 0 10-1.024-.854l1.024.854zM4.53 8.47l2 2 .942-.942-2-2-.942.942zm2.983 1.956l3.333-4-1.024-.854-3.333 4 1.024.854zm6.155-2.76a6 6 0 01-6 6V15A7.333 7.333 0 0015 7.667h-1.333zm-6 6a6 6 0 01-6-6H.333A7.333 7.333 0 007.667 15v-1.333zm-6-6a6 6 0 016-6V.333A7.333 7.333 0 00.333 7.667h1.334zm6-6a6 6 0 016 6H15A7.333 7.333 0 007.667.333v1.334z",
  fill: "#00CF80"
});

var SvgBespokenIconPassed = function SvgBespokenIconPassed(props) {
  return React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none"
  }, props), _ref);
};

export default SvgBespokenIconPassed;